import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+300',
    label: 'Docentes e instituciones'
  }, {
    value: '+2.000',
    label: 'Actividades listas'
  }, {
    value: '3.500+',
    label: 'Horas ahorradas'
  }, {
    value: '99%',
    label: 'De satisfacción'
  }];
  return <section className="py-10 border-y border-brand-creamDark bg-white/40" data-id="element-138">
      <div className="max-w-5xl mx-auto px-4" data-id="element-139">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-brand-creamDark/0 md:divide-brand-creamDark" data-id="element-140">
          {stats.map((stat, i) => <div key={i} className="flex flex-col items-center justify-center" data-id="element-141">
              <span className="text-3xl md:text-4xl font-serif font-bold text-brand-text mb-2" data-id="element-142">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-brand-gray uppercase tracking-wider font-medium" data-id="element-143">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}